import * as React from 'react';
import { Box, useMediaQuery, Image } from '@chakra-ui/react';
import { GatsbyImage, getImage, StaticImage } from 'gatsby-plugin-image';
import { navigate } from 'gatsby';

export default function ThumbWithCat(props) {
  const post = props.node;
  const [isLaptop] = useMediaQuery('(min-width: 1160px) and (max-width: 1540px)');
  const badgeHeight =
    props.badge && props.badge === 'small' && isLaptop
      ? '250px'
      : props.badge && props.badge === 'small'
      ? '200px'
      : props.maxheight
      ? '100%'
      : 'auto';
  const type = props?.type ?? null;
  let img = post && post.featuredImage && post.featuredImage.node ? getImage(post.featuredImage.node.localFile) : null;

  const hasSubCategory =
    post.categories && post.categories?.nodes ? post.categories.nodes.filter(category => category.ancestors) : null;
  const currentSubCategory = hasSubCategory
    ? hasSubCategory.filter(subCategory => subCategory.id === props?.context?.id)
    : null;
  const subCategory =
    hasSubCategory && currentSubCategory ? currentSubCategory[0]?.name : hasSubCategory ? hasSubCategory[0].name : null;

  const currentTopLevelCat =
    post && post.categories && post.categories.nodes
      ? post.categories.nodes.filter(category => category.id === props?.context?.id)
      : null;
  const topLevelCats =
    post && post.categories && post.categories.nodes && post.categories.nodes[0] ? post.categories.nodes[0].name : null;
  const topLevelCat = currentTopLevelCat && currentTopLevelCat.length > 0 ? currentTopLevelCat[0].name : topLevelCats;
  const cat = subCategory ? subCategory : topLevelCat ? topLevelCat : null;
  let postIcon =
    post && post?.types && post?.types?.nodes && post?.types?.nodes[0]?.productTypeOptions
      ? post?.types?.nodes[0]?.productTypeOptions?.icon?.sourceUrl
      : null;

  const checkIsNew = date => {
    const currentDate = new Date();
    const postDate = new Date(date);

    // Calculate the difference in milliseconds between the two dates
    const timeDifference = currentDate.getTime() - postDate.getTime();
    // Calculate the number of days
    const daysDifference = timeDifference / (1000 * 3600 * 24);
    // Check if the input date is within a 30-day range from the current date
    const isNew = daysDifference >= 0 && daysDifference <= 30 ? true : false;
    return isNew;
  };
  const isNew = type && type === 'tutorial' ? checkIsNew(post.date) : false;
  const lang = post?.language?.code ?? 'PL';

  const decodeHash = (anchor, hashedValue) => {
    if (anchor.dataset.unhashed !== 'true') {
      anchor.dataset.unhashed = 'true';
      anchor.href = atob(hashedValue);
    }
  };

  const navigateTo = (anchor, anchorValue) => {
    anchor.preventDefault();
    navigate(atob(anchorValue));
  };

  return (
    <Box
      className={'featuredImage'}
      position={'relative'}
      display={'flex'}
      height={{ base: 'auto', md: badgeHeight }}
      style={{
        aspectRatio: `${
          props?.variant && props.variant === 'recomended'
            ? 'none'
            : props?.variant && props.variant === 'featured'
            ? '1.625/1'
            : type && type === 'tutorial'
            ? '1.82/1'
            : type && type === 'video'
            ? '16/9'
            : '1.5/1'
        }`,
      }}
      overflow={'hidden'}
      // boxShadow={'0 0 40px rgba(0,0,0,.1)'}
      sx={{
        '.gatsby-image-wrapper': { transition: 'all 0.3s ease-out' },
        '.gatsby-image-wrapper img': { objectFit: 'cover' },
        '.gatsby-image-wrapper:hover': { transform: 'scale(1.085)' },
        '.gatsby-image-wrapper:hover:after': { transform: 'translate(-50%, -50%) scale(.915) rotate(360deg)' },
        // '.gatsby-image-wrapper:before' : {
        //     content:'""',
        //     position:'absolute',
        //     inset:'0',
        //     boxShadow:'inset 0 0 40px rgba(0,0,0,.1)',
        //     zIndex:'2',
        // },
      }}
      {...props}
    >
      {img ? (
        <Box
          className="relative"
          cursor={'pointer'}
          onMouseOver={e => decodeHash(e.target, btoa(post.uri))}
          onClick={e => navigateTo(e, btoa(post.uri))}
        >
          <Box
            h={'100%'}
            as={GatsbyImage}
            image={img}
            alt={post.title ?? ''}
            transition={'all 0.3s ease-out'}
            _before={{
              display: type && type === 'video' ? 'block' : 'none',
              content: '""',
              position: 'absolute',
              inset: '0',
              bgColor: '#000',
              opacity: '.4',
              zIndex: '1',
            }}
            _after={{
              display: type && type === 'video' ? 'block' : 'none',
              content:
                "url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' width='50' height='50' viewBox='0 0 50 50'%3e%3cg transform='translate(0 0)'%3e%3cg fill='none' stroke='%23fff' stroke-width='4'%3e%3ccircle cx='25' cy='25' r='25' stroke='none'/%3e%3ccircle cx='25' cy='25' r='23' fill='none'/%3e%3c/g%3e%3c/g%3e%3cg transform='translate(21.877 31.266) rotate(-90)'%3e%3crect width='4.175' height='4.175' transform='translate(12.5 0.039) rotate(90)' fill='%23fff'/%3e%3crect width='4.175' height='4.175' transform='translate(4.175 4.175) rotate(-180)' fill='%23fff'/%3e%3crect width='4.175' height='4.175' transform='translate(8.325 4.188) rotate(90)' fill='%23fff'/%3e%3c/g%3e%3c/svg%3e\")",
              position: 'absolute',
              top: '50%',
              left: '50%',
              zIndex: '2',
              transform: 'translate(-50%,-50%)',
              transition: 'all 0.25s ease-out',
              h: '50px',
            }}
          />
          {postIcon && (
            <Box
              position={'absolute'}
              top={'10px'}
              right={'10px'}
              background={'white'}
              w={'40px'}
              h={'40px'}
              display={'flex'}
              justifyContent={'center'}
              alignItems={'center'}
              borderRadius={'50%'}
            >
              <Image src={postIcon} alt="" />
            </Box>
          )}
        </Box>
      ) : (
        <>
          {type && type === 'tutorial' ? (
            <StaticImage src={'./images/thumb-tutorial@2x.jpg'} alt={'thumbnail'} transition={'all 0.3s ease-out'} />
          ) : (
            <StaticImage src={'./images/thumb@2x.jpg'} alt={'thumbnail'} transition={'all 0.3s ease-out'} />
          )}
        </>
      )}
      {isNew && (
        <Box
          as={'span'}
          pos={'absolute'}
          bottom={'42px'}
          left={'0'}
          color={'#fff'}
          bgColor={'ui.green'}
          m={'.55rem .75rem'}
          borderRadius={'50px'}
          lineHeight={'1.6'}
          zIndex={'2'}
          w={'auto'}
          p={'5px 10px'}
          textDecoration={'none'}
          boxShadow={'0 0 20px rgba(0,0,0,.1)'}
          whiteSpace={'nowrap'}
          overflow={'hidden'}
          textOverflow={'ellipsis'}
          maxWidth={'calc(100% - 1.5rem)'}
          fontWeight={'bold'}
          fontSize={props?.variant && props.variant === 'recomended' ? '11px' : '12px'}
        >
          {lang === 'EN' ? 'New' : 'Nowość'}
        </Box>
      )}
      {cat && cat !== 'Uncategorized' && (
        <Box
          as={'span'}
          color={'#28aae2'}
          bgColor={type && type === 'tutorial' ? '#E9F6FC' : '#fff'}
          m={'.55rem .75rem'}
          fontSize={props?.variant && props.variant === 'recomended' ? '11px' : '12px'}
          style={{
            bottom: '5px',
            fontWeight: 'bold',
            borderRadius: '50px',
            left: '0',
            lineHeight: { base: '1.6' },
            position: 'absolute',
            textDecoration: 'none',
            width: 'auto',
            padding: '5px 10px',
            zIndex: '2',
            boxShadow: '0 0 20px rgba(0,0,0,.1)',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            maxWidth: 'calc(100% - 1.5rem)',
          }}
        >
          {cat}
        </Box>
      )}
    </Box>
  );
}
